import type { BaseTreeItem } from '@kastjs/runtime-core';

// 生成本地路由的map表
export function genLocalRouterMap(routers: BaseTreeItem[]) {
  const localRouterMap: Map<string, BaseTreeItem> = new Map();
  function routerRecursion(routers?: BaseTreeItem[]) {
    if (routers) {
      for (let router of routers) {
        if (router.path) {
          localRouterMap.set(router.path, router);
        }
        if (router.children) {
          routerRecursion(router.children);
        }
      }
    }
  }
  routerRecursion(routers);
  return localRouterMap;
}
